import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { RouterProvider } from "react-router-dom";



import { router } from "./routes";
import { ThemeProvider } from "./theme/ThemeContext";
import GlobalThemeToggle from "./theme/GlobalThemeToggle";
import { LanguageProvider } from "./i18n/LanguageContext";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <RouterProvider router={router} />
      </LanguageProvider>
      <GlobalThemeToggle />
      <ToastContainer rtl position="top-right" autoClose={4000} theme="colored" />
    </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
